export default (cookie_name, cookie_value, cookie_expiration_days, cookie_path, cookie_domain) => {
    let date = new Date();
    date.setTime(date.getTime() + (cookie_expiration_days * 24 * 60 * 60 * 1000));
    if (cookie_domain !== null) {
        document.cookie = `${cookie_name}=${cookie_value};expires=${date.toUTCString()};path=${cookie_path};Domain=${cookie_domain};samesite=none;secure`;
    } else {
        document.cookie = `${cookie_name}=${cookie_value};expires=${date.toUTCString()};path=${cookie_path};samesite=none;secure`;
    }
}